import { z } from "zod";
/** public.memberships.role — replaces is_office_user() (ADR-002). */
export const MembershipRole = z.enum([
    "staff",
    "installer_internal",
    "installer_external",
    "member",
    "supplier",
]);
/** An agent actor's "role" is the desk it is acting as. Desks live in emma-hub
 *  (`emma_agent` rows); the backbone only needs a stable id to write on the audit row. */
export const ActorRole = z.union([MembershipRole, z.literal("agent")]);
export const Actor = z.object({
    kind: z.enum(["human", "agent"]),
    /** human: auth.users id, or work-order-link:<installation> for a server-verified scoped bearer. agent: `emma` or a desk id such as `lead-desk`. */
    id: z.string().min(1),
    role: ActorRole,
    /** org scope for installer_external and supplier; null for staff/members/agents. */
    org_id: z.string().nullable().default(null),
});
/** Where the proposal came from. `emma` = any of her channels; the channel itself
 *  is a delivery detail carried on the case, not on the actor. */
export const Surface = z.enum(["crm", "installer", "web", "mobile", "emma", "adapter", "system"]);
//# sourceMappingURL=actor.js.map